import React from 'react';
import { AAccentLineProps, AAccentLineSize, AAccentLineAlignment } from './AAccentLine.types';
import * as Styled from './AAccentLine.styles';

const COMPONENT_NAME = 'a-web-ui-kit-AAccentLine';
const TEST_ID = 'web-ui-kit-AAccentLine';

export function AAccentLine({
  size = AAccentLineSize.OnePx,
  alignment = AAccentLineAlignment.Left,
  ...rest
}: AAccentLineProps) {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      alignment={alignment}
      size={size}
      {...rest}
    >
      <span className="t-accent-rule"></span>
    </Styled.Wrapper>
  );
}

export { AAccentLineSize, AAccentLineAlignment, TEST_ID as A_ACCENT_LINE_TEST_ID };
